@if (circleModeBtn()) {
  <div
    class="px-4 mx-auto lg:px-6"
    [ngClass]="{
      'container py-8': mode() === 'circle',
    }"
  >
    @if (circleService.updatingCircle()) {
      <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div class="p-8 bg-white rounded-sm shadow-lg">
          <axpo-spinner size="normal">
            {{ 'core.loading' | transloco }}
          </axpo-spinner>
        </div>
      </div>
    }
    <div class="m-4">
      @if (mode() === 'circle') {
        <div class="flex justify-between flex-col sm:flex-row">
          <axpo-typography [variant]="'title-xl'" [weight]="'bold'">
            {{ circle()?.name }}
          </axpo-typography>
          <div class="flex justify-center gap-2 mt-2 sm:justify-end sm:mt-0">
            <axpo-button
              [ngClass]="{
                'w-full': isSmallestView(),
              }"
              (click)="checkForUnsavedChangesElsePerformAction('openPhoneDialog')"
            >
              {{ 'switchboard.managePhoneNumbers' | transloco }}
            </axpo-button>
            @if (!isSmallestView() && isManageContactsAllowed()) {
              @if (circleModeBtn() === 'onCall' || circleModeBtn() === 'isOnSite') {
                <axpo-button
                  (click)="checkForUnsavedChangesElsePerformAction('toggleManageContacts')"
                >
                  {{ 'switchboard.manageContacts' | transloco }}
                </axpo-button>
              } @else {
                <axpo-button (click)="checkForUnsavedChangesElsePerformAction('toggleManageCalls')">
                  {{ 'switchboard.manageCalls' | transloco }}
                </axpo-button>
                <axpo-button (click)="addContact()">
                  {{ 'switchboard.addContact' | transloco }}
                </axpo-button>
              }
            }
          </div>
          @if (isSmallestView() && isManageContactsAllowed()) {
            <div class="w-full mt-2">
              @if (circleModeBtn() === 'onCall' || circleModeBtn() === 'isOnSite') {
                <axpo-button (click)="toggleManageContacts()">
                  {{ 'switchboard.manageContacts' | transloco }}
                </axpo-button>
              } @else {
                <axpo-button (click)="toggleManageCalls()">
                  {{ 'switchboard.manageCalls' | transloco }}
                </axpo-button>
              }
            </div>
            @if (circleModeBtn() !== 'onCall' && circleModeBtn() !== 'isOnSite') {
              <div class="w-full mt-2">
                <axpo-button (click)="addContact()">
                  {{ 'switchboard.addContact' | transloco }}
                </axpo-button>
              </div>
            }
          }
        </div>

        <app-tabs
          (tabSelected)="tabSelectionChanged($event)"
          [tabItems]="circleTabs()"
          [selectedTabId]="circleModeBtn()"
        ></app-tabs>
      }
    </div>
    @if (circleModeBtn() === 'isOnSite') {
      <div class="flex flex-col lg:flex-row">
        @if (onSite()) {
          <div class="w-full lg:w-1/2">
            <app-subgroup-list-selection
              [(clearSelected)]="selectedUser"
              [selectionGroupId]="getSelectionGroupId()"
              [subgroup]="onSite()"
              (userSelected)="onUserChanged($event)"
              [toggleProperty]="circleModeBtn()"
              [mode]="selectionMode()"
              [allDisabled]="allDisabled()"
              [circleId]="circleId()"
              [allowDeleteManuallyAddedContacts]="isDeleteManuallyAddedAllowed"
              (openCustomNumberModal)="openCustomNumberModal()"
            ></app-subgroup-list-selection>
          </div>
        }
        @if (answeringMachine()) {
          <div class="w-full lg:w-1/2">
            <app-subgroup-list-selection
              [(clearSelected)]="selectedUser"
              [selectionGroupId]="getSelectionGroupId()"
              [subgroup]="answeringMachine()"
              (userSelected)="onUserChanged($event)"
              [toggleProperty]="circleModeBtn()"
              [mode]="selectionMode()"
              [allDisabled]="allDisabled()"
              [circleId]="circleId()"
              [allowDeleteManuallyAddedContacts]="isDeleteManuallyAddedAllowed"
              (openCustomNumberModal)="openCustomNumberModal()"
            ></app-subgroup-list-selection>
          </div>
        }
      </div>
    }
    @for (organization of circle()?.organizations; track organization.id) {
      @if (organization.redirectOrgNumber && circleModeBtn() === 'onCall') {
        <div class="flex flex-col justify-center lg:flex-row">
          <div class="flex-1">
            <div class="m-4 flex justify-between border-b-2 lg:max-w-[calc(50vw-2.5rem)] pb-1">
              <div class="w-1/3">
                <axpo-typography variant="body-m">
                  {{ organization.redirectOrgName }}
                </axpo-typography>
                <div class="min-h-4">
                  <axpo-typography variant="body-s">
                    {{ 'switchboard.redirectForOnCall' | transloco }}
                  </axpo-typography>
                </div>
              </div>
              <div class="w-1/3">
                <axpo-typography>
                  {{ organization.redirectOrgNumber }}
                </axpo-typography>
              </div>
              <div class="w-6 h-6"></div>
              <div>
                <app-radio
                  [(checked)]="organization.redirectNow"
                  [active]="true"
                  [selectionGroupId]="getSelectionGroupId(organization.id)"
                  [user]="getRedirectUser()"
                  (selectionChanged)="selectRedirect(getRedirectUser(), organization)"
                ></app-radio>
              </div>
            </div>
          </div>
          <div class="flex-1"></div>
        </div>
      }

      <div class="flex flex-col justify-center lg:flex-row">
        <!-- Left Row -->
        <div class="flex-1">
          @for (subgroup of beforeMedian(organization.subgroups); track subgroup.id) {
            <div
              [ngClass]="{
                'mt-4': $index === 0 && !isMobileView(),
                'mt-8': $index > 0 || isMobileView(),
              }"
            >
              <app-subgroup-list-selection
                [(clearSelected)]="selectedUser"
                [selectionGroupId]="getSelectionGroupId(organization.id)"
                [subgroup]="subgroup"
                (userSelected)="onUserChanged($event)"
                [toggleProperty]="circleModeBtn()"
                [mode]="selectionMode()"
                [allDisabled]="allDisabled()"
                [circleId]="circleId()"
                [allowDeleteManuallyAddedContacts]="isDeleteManuallyAddedAllowed"
                (openCustomNumberModal)="openCustomNumberModal()"
              ></app-subgroup-list-selection>
            </div>
          }
        </div>

        <!-- Right Row -->
        <div class="flex-1">
          @for (subgroup of afterMedian(organization.subgroups); track subgroup.id) {
            <div
              [ngClass]="{
                'mt-4': $index === 0 && !isMobileView(),
                'mt-8': $index > 0 || isMobileView(),
              }"
            >
              <app-subgroup-list-selection
                [(clearSelected)]="selectedUser"
                [selectionGroupId]="getSelectionGroupId(organization.id)"
                [subgroup]="subgroup"
                (userSelected)="onUserChanged($event)"
                [toggleProperty]="circleModeBtn()"
                [mode]="selectionMode()"
                [allDisabled]="allDisabled()"
                [circleId]="circleId()"
                [allowDeleteManuallyAddedContacts]="isDeleteManuallyAddedAllowed"
                (openCustomNumberModal)="openCustomNumberModal()"
              ></app-subgroup-list-selection>
            </div>
          }
        </div>
      </div>
    }
  </div>
  @if (mode() === 'circle') {
    <div
      #stickyContainer
      class="sticky-buttons-container sticky bottom-0 bg-white"
      [ngClass]="{ 'is-stuck': isStuck() }"
    >
      <div class="container flex justify-end gap-2 p-4 px-4 lg:px-6 mx-auto z-10">
        <axpo-button (click)="checkForUnsavedChangesElsePerformAction('back')" type="ghost">
          {{ 'core.back' | transloco }}
        </axpo-button>
        @if (circleModeBtn() !== 'activeOnCall' && circleModeBtn() !== 'activeOnSite') {
          <axpo-button [disabled]="onCallOrOnSiteChange" (click)="save()">
            {{ 'core.save' | transloco }}
          </axpo-button>
        } @else {
          <axpo-button [disabled]="activeUsersChange" (click)="saveManageContacts()">
            {{ 'core.save' | transloco }}
          </axpo-button>
        }
      </div>
    </div>
  }
} @else {
  <div class="flex items-center justify-center m-2">
    <axpo-typography variant="body-l" [weight]="'normal'">
      {{ 'switchboard.currentSelectionNotAvailable' | transloco }}
    </axpo-typography>
  </div>
}
@if (addNewContactDialog()) {
  <axpo-dialog
    title="{{ 'switchboard.addContact' | transloco }}"
    cancelText="{{ 'core.cancel' | transloco }}"
    confirmText="{{ 'core.save' | transloco }}"
    textAlign="left"
    [processBeforeClose]="true"
    [loadingStateText]="'core.loading' | transloco"
    [dataLoaded]="circleService.updatingCircle()"
    (takenAction)="contactDialogClosed($event)"
    [saveDisabled]="!formManager?.isValid && !!formManager?.showErrorOnLoad()"
    [abortSaving]="abortDialogSaving()"
  >
    <div class="flex flex-col space-y-4 min-h-[350px]">
      <axpo-form-element
        formId="subwork"
        label="{{ 'switchboard.subgroup' | transloco }}"
        formType="select"
        [(value)]="newContactSubwork"
        (errorEmitter)="formValidation($event, 'subwork')"
        [errorMessageInput]="this.formManager?.getField('subwork')?.errorMessage()"
        [options]="subgroupOptions()"
        [required]="true"
      ></axpo-form-element>
      <app-location-autocomplete
        formId="name"
        [required]="true"
        [entries]="searchQueryResult()"
        [selectedEntries]="selectedSearchResults()"
        [isLoading]="circleService.searchingUser()"
        placeholder="{{ 'incidentDetail.contactsData.addExistingContact' | transloco }}"
        (debounceValue)="searchValueChanged($event)"
        (entryAdded)="searchEntrySelected($event)"
        (entryRemoved)="searchEntryRemoved($event)"
        [isLocations]="false"
        [disabled]="!newContactSubwork()"
      ></app-location-autocomplete>
      @if (!formManager?.isValid && formManager?.getField('name')?.errorMessage()) {
        <div class="whitespace-nowrap text-primary pb-2 relative top-[-30px]">
          <axpo-typography variant="body-s">
            {{ formManager?.getField('name')?.errorMessage() }}
          </axpo-typography>
        </div>
      }
    </div>
  </axpo-dialog>
}

@if (showSaveDialog && actionToPerform()) {
  <axpo-dialog
    title="{{ 'switchboard.unsavedChangesDialogTitle' | transloco }}"
    confirmText="{{ 'core.cancel' | transloco }}"
    textAlign="left"
    [processBeforeClose]="true"
    (takenAction)="actionToPerform.set(undefined)"
  >
    <div class="flex flex-col space-y-4">
      <axpo-typography variant="body-m">
        {{ 'switchboard.unsavedChangesDialog' | transloco }}
      </axpo-typography>
      @if (actionToPerform() === 'toggleManageCalls') {
        <axpo-button
          (click)="saveManageContacts(); toggleManageCalls(); actionToPerform.set(undefined)"
        >
          {{ 'switchboard.saveAndContinue' | transloco }}
        </axpo-button>
        <axpo-button (click)="resetState(); toggleManageCalls()" [style]="'secondary'" type="ghost">
          {{ 'switchboard.continueWithoutSaving' | transloco }}
        </axpo-button>
      } @else if (actionToPerform() === 'toggleManageContacts') {
        <axpo-button (click)="save(); toggleManageContacts(); actionToPerform.set(undefined)">
          {{ 'switchboard.saveAndContinue' | transloco }}
        </axpo-button>
        <axpo-button
          (click)="resetState(); toggleManageContacts()"
          [style]="'secondary'"
          type="ghost"
        >
          {{ 'switchboard.continueWithoutSaving' | transloco }}
        </axpo-button>
      } @else if (actionToPerform() === 'back') {
        <axpo-button (click)="saveManageContacts(); save(); back(); actionToPerform.set(undefined)">
          {{ 'switchboard.saveAndContinue' | transloco }}
        </axpo-button>
        <axpo-button (click)="resetState(); back()" [style]="'secondary'" type="ghost">
          {{ 'switchboard.continueWithoutSaving' | transloco }}
        </axpo-button>
      } @else if (actionToPerform() === 'openPhoneDialog') {
        <axpo-button (click)="handleSaveBeforeOpeningPhoneDialos()">
          {{ 'switchboard.saveAndContinue' | transloco }}
        </axpo-button>
        <axpo-button (click)="resetState(); back()" [style]="'secondary'" type="ghost">
          {{ 'switchboard.continueWithoutSaving' | transloco }}
        </axpo-button>
      }
    </div>
  </axpo-dialog>
}
@if (showEditNumberDialog()) {
  <axpo-dialog
    title="{{ 'switchboard.phoneNumbers' | transloco }}"
    cancelText="{{ 'core.cancel' | transloco }}"
    confirmText="{{ 'core.save' | transloco }}"
    textAlign="left"
    [processBeforeClose]="true"
    [loadingStateText]="'core.loading' | transloco"
    [dataLoaded]="true"
    (takenAction)="numberDialogClosed($event)"
    [saveDisabled]="!phoneFormManager?.isValid"
  >
    <div class="flex flex-col space-y-4 min-h-[350px]">
      @if (this.circleService.loadingUserNumbers()) {
        <div class="flex justify-center items-center h-full">
          <axpo-spinner size="lg"></axpo-spinner>
        </div>
      } @else {
        @if (!!localUserNumbers()?.defaultPhoneNumber) {
          <div class="flex">
            <axpo-form-element
              [formType]="'text'"
              [formId]="'defaultNumber'"
              [value]="localUserNumbers()?.defaultPhoneNumber?.phoneNumber"
              [label]="'switchboard.defaultPhoneNumber' | transloco"
              [noPadding]="true"
              class="flex-1 pr-6"
              [disabled]="true"
            ></axpo-form-element>
            <div class="mt-6 flex items-center">
              <app-radio
                [checked]="localUserNumbers()?.defaultPhoneNumber?.active"
                [active]="true"
                [selectionGroupId]="'numbers'"
                [user]="localUserNumbers()?.defaultPhoneNumber"
                (selectionChanged)="defaultNumberSelected()"
              ></app-radio>
            </div>
          </div>
        }

        <div class="flex">
          <axpo-form-element
            [formType]="'text'"
            [formId]="'customNumber'"
            [(value)]="this.customPhoneNumber"
            [noPadding]="true"
            [label]="'switchboard.customPhoneNumber' | transloco"
            [errorMessageInput]="phoneFormManager?.getField('customNumber')?.errorMessage()"
            class="flex-1 pr-6"
          ></axpo-form-element>
          <div
            class="mt-6 flex items-center"
            [ngClass]="{
              'pb-4': phoneFormManager?.getField('customNumber')?.errorId(),
            }"
          >
            <app-radio
              [checked]="localUserNumbers()?.customPhoneNumber?.active || false"
              [active]="!!localUserNumbers()?.customPhoneNumber?.phoneNumber"
              [selectionGroupId]="'numbers'"
              [user]="localUserNumbers()?.customPhoneNumber"
              (selectionChanged)="customNumberSelected()"
            ></app-radio>
          </div>
        </div>
      }
    </div>
  </axpo-dialog>
}
